
(() => {
  const hosts = { 'gatee.eu': 'EUR', 'pl.gatee.eu': 'PLN', 'us.gatee.eu': 'USD' };
  const sourceRegion = hosts[location.hostname];
  if (!sourceRegion) return;
  const params = new URLSearchParams(location.search);
  const simulation = params.has('geolizr_country') || params.has('geolizr_ip');
  const blocked = /^\/(?:cart|checkouts?|account|challenge)(?:\/|$)/.test(location.pathname);
  const campaignKey = /^(?:utm_[a-z_]+|gclid|dclid|fbclid|msclkid|ttclid|wbraid|gbraid)$/i;
  const preferenceKey = 'gate_store_preference';
  const readPreference = () => document.cookie.split('; ').find(item => item.startsWith(preferenceKey + '='))?.split('=')[1];
  const remember = region => {
    if (!simulation && Object.values(hosts).includes(region)) {
      document.cookie = preferenceKey + '=' + region + '; Max-Age=2592000; Path=/; Domain=gatee.eu; SameSite=Lax; Secure';
    }
  };
  const campaignUrl = value => {
    const url = new URL(value, location.origin);
    if (!hosts[url.hostname]) return value;
    params.forEach((value, key) => { if (campaignKey.test(key)) url.searchParams.set(key, value); });
    return url.href;
  };
  const frameCss = `
    @font-face{font-family:GATERegionSaira;src:url(https://gatee.eu/cdn/shop/files/Saira-Bold.ttf);font-weight:700;font-display:swap}
    @font-face{font-family:GATERegionSoleto;src:url(https://gatee.eu/cdn/shop/files/Soleto_Rg.ttf);font-weight:400;font-display:swap}
    @font-face{font-family:GATERegionSoleto;src:url(https://gatee.eu/cdn/shop/files/Soleto_Bd.ttf);font-weight:700;font-display:swap}
    html{background:#0a1118}body{box-sizing:border-box;margin:0!important;padding:32px!important;background:radial-gradient(ellipse at 100% 0,#20312566,transparent 65%),#0a1118!important;color:#f4f7f8!important;font-family:GATERegionSoleto,Arial,sans-serif!important;line-height:1.55!important}
    *,*:before,*:after{box-sizing:border-box}.gate-region-brand{display:flex;align-items:center;justify-content:space-between;gap:24px;padding:0 24px 22px 0;margin:0 0 25px;border-bottom:1px solid #2b3942}.gate-region-brand img{display:block;width:98px;height:auto}.gate-region-currency{border:1px solid #4e6650;border-radius:5px;padding:5px 10px;color:#acd28b;font:700 13px GATERegionSaira,Arial,sans-serif;letter-spacing:.08em}
    h2{font:700 32px/1.12 GATERegionSaira,Arial,sans-serif!important;letter-spacing:-.02em!important;color:#f4f7f8!important;margin:0 0 16px!important}p{font:400 16px/1.65 GATERegionSoleto,Arial,sans-serif!important;color:#b9c6cb!important;margin:0 0 24px!important}
    a.gate-region-go{display:flex!important;align-items:center;justify-content:space-between;gap:18px;width:100%;min-height:54px;padding:15px 18px!important;border:1px solid transparent;border-radius:7px!important;background:#acd28b!important;color:#0a1810!important;text-decoration:none!important;font:700 16px/1.35 GATERegionSoleto,Arial,sans-serif!important;transition:background .15s}
    a.gate-region-go:hover{background:#c0dda8!important}.gate-region-stay{display:block;width:100%;min-height:48px;margin:12px 0 0!important;padding:12px 16px!important;border:1px solid #43535f!important;border-radius:7px!important;background:transparent!important;color:#e0e7e8!important;font:400 15px/1.35 GATERegionSoleto,Arial,sans-serif!important;text-align:center;cursor:pointer}
    .gate-region-stay:hover{border-color:#acd28b!important}a:focus-visible,button:focus-visible{outline:2px solid #acd28b!important;outline-offset:4px!important}small{display:block;margin-top:20px!important;color:#91a3ad!important;font:400 12px/1.55 GATERegionSoleto,Arial,sans-serif!important}p:has(>.gate-region-go){margin-bottom:0!important}
    @media(max-width:420px){body{padding:26px 22px!important}h2{font-size:28px!important}.gate-region-brand{margin-bottom:22px;padding-bottom:20px}.gate-region-brand img{width:88px}}
  `;
  const wireFrame = () => {
    const frame = document.getElementById('geolizr-popup-content-iframe');
    if (!frame) return;
    const prepare = () => {
      try {
        const doc = frame.contentDocument;
        if (!doc?.body || !doc.querySelector('.gate-region-go')) return;
        if (!doc.getElementById('gate-region-brand-style')) {
          const style = doc.createElement('style'); style.id = 'gate-region-brand-style'; style.textContent = frameCss; doc.head.append(style);
          const brand = doc.createElement('div'); brand.className = 'gate-region-brand';
          const logo = doc.createElement('img'); logo.src = 'https://gatee.eu/cdn/shop/files/GATE_RGB_white_transparent_8266050c-5fee-42ed-b2c7-202c54251de4.png'; logo.alt = 'GATE'; logo.width = 98;
          const badge = doc.createElement('span'); badge.className = 'gate-region-currency'; badge.textContent = doc.querySelector('[data-gate-store]')?.dataset.gateStore || '';
          brand.append(logo, badge); doc.body.prepend(brand);
          doc.addEventListener('click', event => {
            const link = event.target.closest('a[data-gate-store]');
            if (link) { link.href = campaignUrl(link.href); remember(link.dataset.gateStore); }
            if (event.target.closest('.gate-region-stay')) remember(sourceRegion);
          }, true);
          const updateHeight = () => { frame.style.setProperty('height', Math.ceil(doc.body.scrollHeight) + 'px', 'important'); };
          new ResizeObserver(updateHeight).observe(doc.body);
          doc.fonts?.ready.then(updateHeight);
          updateHeight();
        }
      } catch (_) {}
    };
    if (!frame.dataset.gateRegionObserved) { frame.dataset.gateRegionObserved = 'true'; frame.addEventListener('load', prepare); }
    prepare(); setTimeout(prepare, 100); setTimeout(prepare, 500);
  };
  document.addEventListener('popup.preShow', event => {
    if (!simulation && (readPreference() || blocked)) event.detail.dismissed = true;
  });
  document.addEventListener('popup.show', wireFrame);
  window.addEventListener('message', event => {
    const frame = document.getElementById('geolizr-popup-content-iframe');
    if (frame && event.source === frame.contentWindow && event.data === 'GeolizrClosePopup') remember(sourceRegion);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || !link.closest('[id$="__husar_launch_utility"]')) return;
    const url = new URL(link.href, location.origin);
    if (hosts[url.hostname] && url.hostname !== location.hostname) {
      if (url.pathname === '/' && !blocked) url.pathname = location.pathname;
      link.href = campaignUrl(url.href); remember(hosts[url.hostname]);
    }
  }, true);
  let attempts = 0;
  const connect = () => {
    const geolizr = window.Geolizr;
    if (typeof geolizr?.getHelper !== 'function') { if (++attempts < 60) setTimeout(connect, 200); return; }
    const helper = geolizr.getHelper();
    if (!helper.gateCampaignUrls) {
      const replace = helper.replaceUrlPlaceholder;
      helper.replaceUrlPlaceholder = function(value, data) {
        const result = replace.call(this, value, data);
        return typeof value === 'string' && value.includes('%path') ? campaignUrl(result) : result;
      };
      helper.gateCampaignUrls = true;
    }
    wireFrame();
  };
  connect();
})();

